// @flow
import React from 'react';

import ResourceCard from './resource-card';

import { ResourceType } from '../types/resource';

type DashboardCardsProps = {
  resources: ResourceType[],
  shared?: boolean,
  token?: string,
  showCheckbox?: boolean,
  toggleCardCheckbox?: (resourceId: any) => void,
  selectedCards?: string[]
}

const DashboardCards = ({
  resources, shared, token, selectedCards, showCheckbox, toggleCardCheckbox
}: DashboardCardsProps) => (
  <ul className='card__records'>
    {resources.map((resource, i) => (
      <ResourceCard
        resource={resource}
        key={i}
        token={token}
        shared={shared}
        showCheckbox={showCheckbox}
        toggleCardCheckbox={toggleCardCheckbox}
        isSelected={selectedCards && selectedCards.includes(resource)}
      />
    ))}
  </ul>
);

export default DashboardCards;


// WEBPACK FOOTER //
// ./src/components/dashboard-cards.js